var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#2ECC71"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0001 20.1699L9.53014 16.6999C9.14014 16.3099 8.51014 16.3099 8.12014 16.6999C7.73014 17.0899 7.73014 17.7199 8.12014 18.1099L12.3001 22.2899C12.6901 22.6799 13.3201 22.6799 13.7101 22.2899L24.2901 11.7099C24.6801 11.3199 24.6801 10.6899 24.2901 10.2999C23.9001 9.90995 23.2701 9.90995 22.8801 10.2999L13.0001 20.1699Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationCheck);
export default __webpack_public_path__ + "static/media/notificationCheck.e3e51a388fb10b42cf264b01e986463d.svg";
export { ForwardRef as ReactComponent };